/** Dispatched before chat Accept All clears Story Bible diff store state. */
export const STORY_BIBLE_ACCEPT_TIPTAP_DIFFS_EVENT = "sudo-accept-story-bible-tiptap-diffs";

export type StoryBibleAcceptTiptapDiffsDetail = {
  searchableIds: string[];
};

export function dispatchAcceptStoryBibleTiptapDiffs(searchableIds: string[]): void {
  if (!searchableIds.length) return;
  window.dispatchEvent(
    new CustomEvent<StoryBibleAcceptTiptapDiffsDetail>(STORY_BIBLE_ACCEPT_TIPTAP_DIFFS_EVENT, {
      detail: { searchableIds },
    }),
  );
}
